import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDefaultHeader } from "../utils/httpClient";
import { userLogout } from "../reduxStore/action/authActions";
import strings from "translate/language";
import { handleDetailResponse } from "utils/utils";

const Header = () => {
  const navigate = useNavigate();
  const [sidebar, setSidebar] = useState(false);
  const [profileDetail, setProfileDetail] = useState({});
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const dispatch = useDispatch();

  const loginSelector = useSelector((state) => state.login);

  useEffect(() => {
    checklogin();
  }, [loginSelector]);
  useEffect(() => {
    var x = window.matchMedia("(max-width: 991px) and (min-width: 200px) ");
    x.addListener(handleSideNav);
  }, []);
  const handleSideNav = (x) => {
    if (x.matches) {
      // If media query matches
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
    } else {
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
    }
  };

  const checklogin = async () => {
    if (loginSelector.response && loginSelector.authToken) {
      if (loginSelector.response.status === 200) {
        await setDefaultHeader("token", loginSelector.response.token);
        var path = window.location.pathname + window.location.search;
        navigate(path ? path : "/dashboard");
      }
    } else {
      navigate("/");
    }
  };
  const LogOut = () => {
    dispatch(userLogout());
    // navigate("/login");
  };

  const openclose = () => {
    if (sidebar) {
      setSidebar(!sidebar);
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
    } else {
      setSidebar(!sidebar);
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
    }
  };
  const userProfileDetailSelector = useSelector(
    (state) => state?.userProfileUpdate
  );

  useEffect(() => {
    if (userProfileDetailSelector.response) {
      const { response } = userProfileDetailSelector;
      if (response.status === 200) {
        const data = handleDetailResponse(response?.data);
        let baseUrl = data?.cp_id ? data?.profile_base_url : data?.base_url;
        setProfileDetail({ ...data, base_url: baseUrl });
      } else {
        setProfileDetail({});
      }
    } else {
      if (loginSelector.response && loginSelector.authToken) {
        if (loginSelector.response.status === 200) {
          setProfileDetail(handleDetailResponse(loginSelector?.response?.data));
        } else {
          setProfileDetail({});
        }
      }
    }
  }, [userProfileDetailSelector]);

  return (
    <div className="page-main-header">
      <div className="main-header-right row">
        <div className="main-header-left d-lg-none">
          <div className="logo-wrapper">
            <a href="/dashboard">
              <img src="/assets/images/JUSTOLOGO.jpg" alt="" />
            </a>
          </div>
        </div>
        <div className="mobile-sidebar d-block">
          <div className="media-body text-right switch-sm">
            <label className="switch">
              <a onClick={() => openclose()}>
                <i className="fa fa-bars theme-fa-icon" aria-hidden="true"></i>
              </a>
            </label>
          </div>
        </div>
        <div className="nav-right col p-0">
          <ul className="nav-menus">
            <li></li>
            <li className="onhover-dropdown">
              <div className="media align-items-center">
                {profileDetail?.profile_picture ? (
                  <div
                    style={{
                      backgroundImage: `url(${profileDetail?.base_url}${profileDetail?.profile_picture})`,
                      width: 45,
                      height: 45,
                      borderRadius: "50%",
                      cursor: "pointer",
                      position: "relative",
                      backgroundSize: "cover",
                      backgroundPosition: "50%",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>
                ) : (
                  <span>
                    <img
                      className="align-self-center pull-right img-50 rounded-circle"
                      src="/assets/images/user.png"
                    />
                  </span>
                )}
                <div className="dotted-animation">
                  <span className="animate-circle" />
                  <span className="main-circle" />
                </div>
              </div>
              <ul className="profile-dropdown onhover-show-div p-10">
                <li>
                  <a>
                    <i className="fa fa-user mr-3" aria-hidden="true" />{" "}
                    <span onClick={() => navigatpage(`/viewuserprofile`)}>
                      {strings.profile}
                    </span>
                  </a>
                </li>
                <li>
                  <a>
                    <i className="fa fa-key mr-3" aria-hidden="true" />{" "}
                    <span onClick={() => navigatpage(`/changepassword`)}>
                      {" "}
                      {strings.changePassword}
                    </span>
                  </a>
                </li>
                <li>
                  <a onClick={() => LogOut()}>
                    <i className="fa fa-sign-out mr-3" aria-hidden="true" />{" "}
                    {strings.logout}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <div className="d-lg-none mobile-toggle pull-right">
            <i data-feather="more-horizontal" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
